import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft, Search, Phone } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PageMeta from "@/components/PageMeta";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  const suggestions = [
    { label: "Forsiden", href: "/", icon: Home, description: "Gå tilbake til startsiden" },
    { label: "Våre drakter", href: "/#drakter", icon: ArrowLeft, description: "Se utvalget av bunader" },
    { label: "Tilbehør", href: "/tilbehor", icon: ArrowLeft, description: "Sko, slips, hårbøyler og mer" },
    { label: "Søk", href: "/sok", icon: Search, description: "Søk etter det du leter etter" },
    { label: "Kontakt oss", href: "/#kontakt", icon: Phone, description: "Vi hjelper deg gjerne" },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <PageMeta
        title="Siden ble ikke funnet (404)"
        description="Beklager, siden du leter etter finnes ikke. Gå tilbake til forsiden for å se våre norskproduserte bunader."
        path={location.pathname}
      />
      <Header />

      <main className="flex-1 flex items-center justify-center pt-24 pb-20 px-6">
        <div className="max-w-lg w-full text-center">
          {/* Decorative 404 */}
          <p className="font-serif text-8xl md:text-9xl text-primary/15 font-bold select-none leading-none mb-2">
            404
          </p>

          <h1 className="font-serif text-2xl md:text-3xl text-foreground mb-3">
            Siden ble ikke funnet
          </h1>
          <p className="text-muted-foreground font-sans leading-relaxed mb-10 max-w-md mx-auto">
            Beklager, vi fant ikke siden du leter etter. Den kan ha blitt flyttet
            eller fjernet. Prøv en av lenkene under.
          </p>

          {/* Quick links */}
          <div className="grid gap-3 sm:grid-cols-2 text-left mb-10">
            {suggestions.map(({ label, href, icon: Icon, description }) => (
              <Link
                key={href}
                to={href}
                className="group flex items-start gap-3 rounded-lg border border-border bg-cream p-4 hover:border-primary/30 hover:shadow-sm transition-all"
              >
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <Icon className="w-4 h-4" />
                </span>
                <div>
                  <span className="font-sans text-sm font-medium text-foreground group-hover:text-primary transition-colors">
                    {label}
                  </span>
                  <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
                </div>
              </Link>
            ))}
          </div>

          {/* Back link */}
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 text-primary font-sans text-sm hover:gap-3 transition-all"
          >
            <ArrowLeft className="w-4 h-4" />
            Gå tilbake til forrige side
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
